<template>
  <section class="card">
    <span class="card_header">
      <span class="card_header-text">Question {{ index + 1 }}</span>
      <span class="card_header-text">
        Response({{getResponse(result.answers)}})
      </span>
    </span>
    <span class="card_container">
      <span v-if="seeMore && !isPhone"
            class="card_container_seeMoreContent">
        <button class="card_container_seeMoreContentBtn"
              @click="seeMore = !seeMore">
          <i class="fas fa-angle-left"/>&nbsp;Back
        </button>
        <span class="card_container_seeMoreContentList">
            <ul class="card_content-right_textListFull">
                <li v-for="answer in result.answers"
                    :key="answer.id"
                    class="card_content-right_textItemFull">
                  {{answer.answer}}
                </li>
              </ul>
          </span>
      </span>
      <span v-if="!seeMore && isPhone" style="margin: 2rem 0 0 2rem;">
        <p class="landscape_text">Please use landscape</p>
        <span class="landscape_container">
          <i class="fas fa-mobile-alt fa-8x landscape"/>
        </span>
      </span>
        <!-- Left Side -->
        <span class="card_content-left" v-if="!seeMore && !isPhone">
          <h3 class="card_content-left_text">
            {{ result.question }}
          </h3>
          <ul v-if="result.questionType !== 'text'"
              class="card_content-left_list">
            <span v-if="result.questionType === 'multi'">
              <li style='padding-bottom: 1rem; display: flex; flex-direction: row'
                  v-for="(option,index) in result.options" :key="index">
                <input type="radio"
                       v-model="selectOptions"
                       @click="fillData(option.option)"
                       :value="option.option" />
                <label class="card_content-left_listItemRadio"
                       :class="{'card_content-left_listItemRadioActive': selectOptions === option.option}">
                  {{option.option}}
                </label>
              </li>
            </span>
            <span v-if="result.questionType === 'radio'">
              <li class="card_content-left_listItem"
                  v-for="(option, index) in result.options"
                  :key="option.id"
                  @click="selectOptions = option.option">
                <span :class="{
                  'card_content-left_listItemActive' : selectOptions === option.option
                }">{{(index + 1)}}.</span>&emsp;<span :class="{
                  'card_content-left_listItemActive' : selectOptions === option.option,
                  'card_content-left_listItemInactive' : selectOptions !== option.option
                }">{{option.option}}</span>
              </li>
            </span>
          </ul>
          <span v-if="result.questionType === 'text'">
            <textarea class="card_content-left_textArea"
                      placeholder="Your Answer here..."
                      disabled="true"/>
          </span>
        </span>
        <!-- Right Side -->
        <span class="card_content-right" v-if="!seeMore && !isPhone">
          <span v-if="getResponse(result.answers) === 0"
                class="card_content_loader">
            <i class="fas fa-user-clock fa-3x" />
            Waiting for feedback from users
          </span>
          <span v-if="result.questionType === 'radio' && getResponse(result.answers) > 0"
          style="margin-top: 1rem;">
            <span v-for="option in result.options" :key="option.id"
                  style="display: flex; flex-direction: row; padding-bottom: 1rem;">
              <progress
                  class="progress is-large"
                  :class="{'is-app' : selectOptions === option.option,
                      'is-secondary' : selectOptions !== option.option}"
                  :value="getProgress(result.answers, option.option)"
                  style="width: 200px; margin-right: 5px;"
                  max="100">
              {{getProgress(result.answers, option.option)}}%
              </progress>
              {{getProgress(result.answers, option.option)}}%
            </span>
          </span>
          <span v-if="result.questionType === 'multi' && getResponse(result.answers) > 0">
            <pie-chart :chartData="datacollection"
                       :options="options"
                       :width="250"
                       :height="250" />
          </span>
          <span v-if="result.questionType === 'text'"
                class="card_content-right_textContainer">
            <ul class="card_content-right_textList">
              <li v-for="answer in result.answers.slice(0, this.cardLimit)"
                  :key="answer.id"
                  class="card_content-right_textItem">
                {{answer.answer}}
              </li>
            </ul>
            <button v-if="getResponse(result.answers) > 0"
                    class="card_content-right_seeMoreBtn"
                    @click="seeMore = !seeMore">
              See More <i class="fas fa-long-arrow-right" />
            </button>
          </span>
        </span>
      </span>
  </section>
</template>
<script>
import PieChart from '@/components/Charts/PieChart.js'
// eslint-disable-next-line no-unused-vars
import ChartJSPluginDatalabels from 'chartjs-plugin-datalabels'

export default {
  components: {
    PieChart
  },
  data: function () {
    return {
      selectOptions: '',
      datacollection: null,
      pieMap: {},
      pieData: [],
      pieLabel: [],
      pieColor: [],
      isLoaded: false,
      cardLimit: 12,
      seeMore: false,
      isPhone: false,
      primaryColor: '',
      secondaryColor: ''
    }
  },
  props: {
    result: {
      type: Object,
      isRequired: true
    },
    index: {
      type: Number,
      isRequired: true
    },
    options: {
      type: Object,
      isRequired: true
    }
  },
  mounted: function () {
    window.addEventListener('orientationchange', this.handleOrientationChange)
    this.getInitialSetup(this.result)
    this.fillData()
    this.getMedia()
  },
  methods: {
    // Phone Check
    getMedia: function () {
      const portrait = window.matchMedia('(orientation: portrait)').matches
      const deviceWidth = window.matchMedia('only screen and (max-width: 500px)').matches
      if (portrait && deviceWidth) {
        this.isPhone = true
      } else {
        this.isPhone = false
      }
    },
    handleOrientationChange: function () {
      const orientation = window.screen.orientation.type
      const deviceWidth = window.matchMedia('only screen and (max-width: 500px)').matches
      if (orientation === 'portrait-primary' && deviceWidth) {
        this.isPhone = true
      } else if (orientation === 'landscape-primary' && deviceWidth) {
        this.isPhone = false
      }
    },
    // Get data
    fillData (selected) {
      const map = new Map()
      const { answers, questionType, options } = this.result
      if (questionType === 'multi' && !this.isLoaded) {
        if (options) {
          options.map(option => {
            map.set(option.option, 0)
          })
        }

        if (answers) {
          map.forEach((value, key) => {
            let count = value
            answers.map(answer => {
              if (key === answer.option) {
                count++
                map.set(key, count)
              }
            })
          })
        }
        map.forEach((value, key) => {
          if (value === 0) {
            map.delete(key)
          } else {
            this.pieData.push(value)
            this.pieLabel.push(key)
          }
        })

        this.pieLabel.map((color, index) => {
          if (index === 0) {
            this.pieColor[index] = this.primaryColor
          } else {
            this.pieColor[index] = this.secondaryColor
          }
        })
        this.pieMap = map
        this.isLoaded = true
      }
      if (selected) {
        this.selectOptions = selected
        const newIndex = this.pieLabel.indexOf(selected)

        this.pieColor.map((color, index) => {
          if (index === newIndex) {
            this.pieColor[index] = this.primaryColor
          } else {
            this.pieColor[index] = this.secondaryColor
          }
        })

        this.datacollection = {
          labels: this.pieLabel,
          datasets: [
            {
              backgroundColor: this.pieColor,
              data: this.pieData
            }
          ]
        }
      } else {
        this.datacollection = {
          labels: this.pieLabel,
          datasets: [
            {
              backgroundColor: this.pieColor,
              data: this.pieData
            }
          ]
        }
      }
    },
    // Set up the data
    getInitialSetup: function (data) {
      this.getColour()
      if (data) {
        this.getInitialSelection(data)
      }
    },
    // Get the initial selection for card
    getInitialSelection: function (array) {
      array.options.map((option, index) => {
        if (index === 0) {
          this.selectOptions = option.option
        }
      })
    },
    // Get colours
    getColour: function () {
      switch (process.env.APP_NAME) {
        case 'Neweng':
          this.primaryColor = '#7A2A90'
          this.secondaryColor = '#58ACAC'
          break
        case 'Ysc':
          this.primaryColor = '#EA002A'
          this.secondaryColor = '#00ADEE'
          break
        case 'Ajas':
          this.primaryColor = '#C3A754'
          this.secondaryColor = '#00ADEE'
          break
        case 'Isef':
          this.primaryColor = '#005587'
          this.secondaryColor = '#ED761E'
          break
        case 'Projectboard':
          this.primaryColor = '#8400F0'
          this.secondaryColor = '#373737'
          break
        case 'Girls-and-steam':
          this.primaryColor = '#804D9F'
          this.secondaryColor = '#FECC07'
          break
        case 'Societyforsciencebcm':
          this.primaryColor = '#CC092F'
          this.secondaryColor = '#231F20'
          break
        case 'Ohiosci':
          this.primaryColor = '#6e0101;'
          this.secondaryColor = '#ffffff'
          break
        case 'Cmniiwsf':
          this.primaryColor = '#0094C4'
          this.secondaryColor = '#BA2990'
          break
        case 'Buckeye':
          this.primaryColor = '#185DAB'
          this.secondaryColor = '#EE2D23'
          break
        case 'Sts':
          this.primaryColor = '#065BAA'
          this.secondaryColor = '#C0C0C0'
          break
        case 'Oasam':
          this.primaryColor = '#185DAB'
          this.secondaryColor = '#FF8300'
          break
        default:
          this.primaryColor = '#EA002A'
          this.secondaryColor = '#00ADEE'
          break
      }
    },
    // Bar graph
    getProgress: function (array, option) {
      let count = 0
      array.map(answer => {
        if (answer.option === option) {
          count++
        }
      })
      return (count / array.length) * 100
    },
    // Bar graph
    getResponse: function (array) {
      let count = 0
      array.map(answer => {
        if (answer.option) {
          count++
        }

        if (answer.answer) {
          count++
        }
      })
      return count
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~styles/utils.scss';

.card {
  border: 1px solid black;
  border-radius: 10px;
  padding: 2rem;
  margin: 2rem 0;
  &_header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    &-text{
      font-size: .825em;
      color: grey;
    }
  }
  &_container {
    display: flex;
    flex-direction: row;
    flex-grow: 1;
    padding-top: 1rem;
    &_seeMoreContent {
      width: 100%;
    }
    &_seeMoreContentBtn {
      width: 6rem;
      height: 2rem;
      margin-left: .5rem;
      background: transparent;
      border: .5px solid $primary;
      border-radius: 5px;
      font-weight: 600;
      color: $primary;
      cursor: pointer;
      &:hover {
        background-color: $primary;
        color: $white;
      }
    }
    &_seeMoreContentList {
      display: flex;
      flex-direction: column;
      padding: 2rem;
    }
  }
  &_content {
    &_loader {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    &-left {
      max-width: 22rem;
      &_text {
        font-weight: bold;
      }
      &_textArea {
        font-size: .8em;
        color: $grey;
        padding: .5rem;
        resize: none;
        min-height: 6rem;
        width: 16rem;
        margin-top: 1rem;
        border-radius: 5px;
        border: .5px solid $primary;
      }
      &_list {
        padding: 2rem;
        min-width: 20rem;
      }
      &_listItemRadio {
        padding: 0 .5rem;
        margin-top: -3px;
      }
      &_listItemRadioActive {
        color: $primary;
      }
      &_listItem {
        padding-bottom: 1rem;
        cursor: pointer;
      }
      &_listItemInactive {
        margin-left: 6px;
      }
      &_listItemActive {
        color: $white;
        background-color: $primary;
        padding: .2rem .5rem;
        border-radius: 5px;
        margin-left: -8px;
      }
    }
    &-right {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      &_textContainer {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
      }
      &_textList {
        min-width: 15rem;
        display: grid;
        grid-template-columns: auto auto;
        grid-gap: .2em 1em;
        font-weight: bold;
        font-size: .9em;
      }
      &_textListFull {
        width: 100%;
        display: grid;
        grid-template-columns: auto auto;
        grid-gap: .2em 1em;
        font-weight: bold;
        font-size: .9em;
      }
      &_textItem {
        max-width: 8rem;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
      &_seeMoreBtn {
        width: 6rem;
        height: 2rem;
        margin-left: .5rem;
        background: transparent;
        border: .5px solid $primary;
        border-radius: 5px;
        font-weight: 600;
        color: $primary;
        cursor: pointer;
        &:hover {
          background-color: $primary;
          color: $white;
        }
      }
    }
  }
   // Progress Button Custom Sizes
  .progress.is-app::-webkit-progress-value {
    background-color: $primary;
  }
  .progress.is-app::-moz-progress-bar {
    background-color: $primary;
  }
  .progress.is-app::-ms-fill {
    background-color: $primary;
  }
  .progress.is-secondary::-webkit-progress-value {
    background-color: $secondary;
  }
  .progress.is-secondary::-moz-progress-bar {
    background-color: $secondary;
  }
  .progress.is-secondary::-ms-fill {
    background-color: $secondary;
  }
  // Custom Radio button style
  input[type='radio'] {
    -webkit-appearance: none;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    outline: none;
    border: 2px solid gray;
  }

  input[type='radio']:before {
    content: '';
    display: block;
    width: 60%;
    height: 60%;
    margin: 20% auto;
    border-radius: 50%;
  }

  input[type="radio"]:checked:before {
    background: $primary;

  }

  input[type="radio"]:checked {
    border-color:$primary;
  }
}

// Phone flip animation
.landscape {
  &_text{
    font-size: 1.5em;
    font-weight: bold;
  }
  &_container {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin: 2rem 0;
  }
  -webkit-animation-name: rotate;
  -webkit-animation-duration: 4.5s;
  -webkit-animation-iteration-count: infinite;
  -webkit-transition-timing-function: linear;
}

@-webkit-keyframes rotate {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(90deg); }
}
</style>
